import React from 'react';

import People from 'features/people/People';

const AboutPeoplePage = () => {
  return (
    <People />
  );
};

export default AboutPeoplePage;
